import {
    HStack,
    VStack,
    Text,
    Tooltip,
    Tag,
    Spinner,
    ModalOverlay,
    ModalHeader,
    ModalContent,
    Modal,
    ModalBody,
    ModalCloseButton,
    PopoverTrigger,
    Popover,
    PopoverBody,
    PopoverContent,
    Box,
    StackDivider,
    Grid,
    GridItem,
    Tabs,
    Tab,
    TabList,
    TabPanels,
    TabPanel,
    Icon,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    IconButton,
    Button,
    PopoverCloseButton,
    PopoverHeader,
} from '@chakra-ui/react';
import {
    ResourceBlockViewProps,
    BlockItemViewProps,
    FormBlockViewProps,
} from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';
import {
    HiDotsHorizontal,
    HiOutlineDocumentText,
    HiOutlineDotsHorizontal,
    HiOutlineTrash,
    HiPlus,
} from 'react-icons/hi';
import { AiOutlineTable } from 'react-icons/ai';
import { BsThreeDots } from 'react-icons/bs';

export function createDocumentFormView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<FormBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        console.log('props', props);

        const fields = [
            {
                id: 'name',
                label: 'Name',
                type: 'text',
            },
            {
                id: 'email',
                label: 'Email',
                type: 'email',
            },
        ];

        return (
            <BlockItem {...props.block}>
                <Tabs variant="soft-rounded" defaultIndex={0} w="full">
                    <TabList as={HStack} spacing={2}>
                        <Tab
                            h={8}
                            bg="none"
                            color="whiteAlpha.500"
                            _hover={{ bg: 'whiteAlpha.50' }}
                            _selected={{ bg: 'whiteAlpha.100', color: 'whiteAlpha.800' }}
                        >
                            <HStack spacing={2}>
                                <Icon as={HiOutlineDocumentText} />
                                <Text>Form</Text>
                            </HStack>
                        </Tab>
                        <Tab
                            h={8}
                            bg="none"
                            color="whiteAlpha.500"
                            _hover={{ bg: 'whiteAlpha.50' }}
                            _selected={{ bg: 'whiteAlpha.100', color: 'whiteAlpha.800' }}
                        >
                            <HStack spacing={2}>
                                <Icon as={AiOutlineTable} />
                                <Text>Responses</Text>
                            </HStack>
                        </Tab>
                    </TabList>
                    <TabPanels py={6}>
                        <TabPanel as={VStack} p={0} spacing={6} w="full" align="start">
                            {fields.map((field) => (
                                <FormControl
                                    key={field.id}
                                    as={VStack}
                                    spacing={4}
                                    borderWidth={1}
                                    borderColor="whiteAlpha.300"
                                    p={6}
                                    borderRadius="lg"
                                    role="group"
                                    _hover={{ borderColor: 'whiteAlpha.400' }}
                                >
                                    <HStack
                                        justify="space-between"
                                        w="full"
                                        align="start"
                                    >
                                        <InputGroup variant="unstyled">
                                            <Input
                                                fontSize="2xl"
                                                fontWeight="bold"
                                                color="whiteAlpha.900"
                                                defaultValue={field.label}
                                                placeholder="Field name"
                                            />
                                        </InputGroup>
                                        <Popover>
                                            <PopoverTrigger>
                                                <IconButton
                                                    bg="none"
                                                    borderColor="whiteAlpha.200"
                                                    borderWidth={1}
                                                    size="sm"
                                                    opacity={0}
                                                    aria-label="More"
                                                    icon={<BsThreeDots fontSize="xl" />}
                                                    _hover={{ bg: 'whiteAlpha.50' }}
                                                    _groupHover={{ opacity: 1 }}
                                                />
                                            </PopoverTrigger>
                                            <PopoverContent
                                                bg="black"
                                                overflow="hidden"
                                                w="auto"
                                                minW="16rem"
                                                fontSize="sm"
                                                _focus={{
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                }}
                                            >
                                                <PopoverHeader
                                                    as={HStack}
                                                    border="none"
                                                    bg="whiteAlpha.200"
                                                    p={3}
                                                    color="whiteAlpha.800"
                                                    fontWeight="semibold"
                                                    justify="space-between"
                                                >
                                                    <Text>Field options</Text>
                                                    <PopoverCloseButton position="initial" />
                                                </PopoverHeader>
                                                <PopoverBody
                                                    as={VStack}
                                                    border="none"
                                                    p={2}
                                                    bg="whiteAlpha.200"
                                                    align="start"
                                                >
                                                    <Button
                                                        w="full"
                                                        size="sm"
                                                        variant="unstyled"
                                                        justifyContent="start"
                                                        alignItems="center"
                                                        px={3}
                                                        textAlign="left"
                                                        leftIcon={
                                                            <Icon as={HiOutlineTrash} />
                                                        }
                                                        _hover={{
                                                            bg: 'whiteAlpha.50',
                                                        }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </PopoverBody>
                                            </PopoverContent>
                                        </Popover>
                                    </HStack>
                                    <InputGroup>
                                        <Input
                                            placeholder="Respondent answer"
                                            borderColor="whiteAlpha.100"
                                            userSelect="none"
                                            readOnly={true}
                                            _placeholder={{
                                                color: 'whiteAlpha.400',
                                                _hover: {
                                                    color: 'whiteAlpha.400',
                                                },
                                            }}
                                            _hover={{
                                                color: 'whiteAlpha.400',
                                            }}
                                        />
                                    </InputGroup>
                                </FormControl>
                            ))}
                            <HStack w="full" justify="center">
                                <Tooltip
                                    placement="bottom"
                                    openDelay={300}
                                    px={2}
                                    py={1}
                                    bg="gray.50"
                                    color="gray.900"
                                    borderRadius="md"
                                    shouldWrapChildren={true}
                                    label="Add field"
                                >
                                    <IconButton
                                        // variant="outline"
                                        // colorScheme="blue"
                                        aria-label="Add field"
                                        borderRadius="full"
                                        borderWidth={1}
                                        borderColor="whiteAlpha.300"
                                        color="whiteAlpha.500"
                                        bg="none"
                                        icon={<Icon as={HiPlus} fontSize="lg" />}
                                        _hover={{
                                            bg: 'whiteAlpha.50',
                                        }}
                                    />
                                </Tooltip>
                            </HStack>
                        </TabPanel>
                        <TabPanel>
                            <Text>Responses</Text>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </BlockItem>
        );
    };
}
